import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { GetToken, GetUser } from 'constants/Global';
import React, { useEffect, useState } from 'react';

const ProtectedRoute: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const token = GetToken();
        const user = GetUser();

        if (token && user) {
            setIsAuthenticated(true);
        } else {
            localStorage.clear();
            setIsAuthenticated(false);
        }

        setIsLoading(false);
    }, []);

    if (isLoading) {
        return <div>Cargando sesión...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
